import isEqualWith from 'lodash/isEqualWith';

const isShallowEqual = (a: any, b: any) =>
  isEqualWith(a, b, (aval, bval, index) =>
    index === undefined ? undefined : Object.is(aval, bval),
  );

export default isShallowEqual;
